import React, { Component } from 'react';

class ChangeValue extends Component {

    
    state = { 
        value : this.props.value == null ? 0 : this.props.value.toFixed(2),
        style : this.props.value < 0 ? {color: "red"} : {color: "green"}
     }

    componentDidUpdate(prevProps) {
  
        if (this.props.value !== prevProps.value) 
        {
            var lststyle = this.state.style;
            if(this.props.value < 0)
                lststyle = {color: "red"}
            else
                lststyle = {color: "green"}
            this.setState({value : this.props.value == null ? 0 : this.props.value.toFixed(2), style : lststyle});  
        }
    }
    render() { 
        return <td style={this.state.style}>%{this.state.value}</td>;
    }

}
 
export default ChangeValue;